

export default (color="black",weight=2)=>`data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
        <path d="M8 10H16" stroke="${color}" stroke-width="${weight}" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M8 14H16" stroke="${color}" stroke-width="${weight}" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M7 10H17" stroke="${color}" stroke-width="${weight}" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M7 14H17" stroke="${color}" stroke-width="${weight}" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M9 17L11 7" stroke="${color}" stroke-width="${weight}" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M13 17L15 7" stroke="${color}" stroke-width="${weight}" stroke-linecap="round" stroke-linejoin="round"></path>
    </g>
</svg>
`)}`;
